module.exports = __webpack_public_path__ + "img/home.a9ca47c3.png";